import { PropsWithChildren } from "react";

import Drawer from "@mui/material/Drawer";

import CompanyDetailsDrawerStyles from "./CompanyDetailsDrawerStyles";

interface ICompanyDetailsDrawerProperties extends PropsWithChildren {
  close: () => void;
  isOpen: boolean;
}

export default function CompanyDetailsDrawer({ children, close, isOpen }: ICompanyDetailsDrawerProperties) {
  return (
    <div>
      <Drawer
        anchor="right"
        ModalProps={{
          BackdropProps: {
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}
        onClose={close}
        open={isOpen}
        sx={CompanyDetailsDrawerStyles.drawer}
        transitionDuration={300}
      >
        {children}
      </Drawer>
    </div>
  );
}
